export default {
    closeCreditAccountTitle: 'Oppsigelse av kredittkortavtale',

    closeCreditAccountFormDescriptionAccount: 'Du er i ferd med å si opp din konto',
    closeCreditAccountFormDescriptionCard: 'Du er i ferd med å si opp ditt',
    closeCreditAccountFormYouHaveChosenCard: 'Du har valgt å avslutte ditt',
    closeCreditAccountFormYouHaveChosenAccount: 'Du har valgt å avslutte din',

    closeCreditAccountSadToHear: 'Det er trist å høre at du ønsker å avslutte ditt kredittkort.',
    closeCreditAccountRemember:
        'Husk at kredittkortet egner seg best til både netthandel, bestilling av reiser, kjøp i utlandet og uforutsette utgifter.',

    closeCreditAccountLeftoverBalanceDescription:
        'Har du utestående beløp, må gjelden innbetales før kredittkortet kan avsluttes. I dette tilfellet vil kredittkortet ditt sperres, men du vil fremdeles motta månedlige faktura inntil gjelden er innfridd.',
    closeCreditAccountLeftoverBalanceTransferDescription:
        'Har du beløp til gode, må pengene overføres til en annen konto du disponerer før kredittkortet avsluttes.',

    closeCreditAccountFormSelectAccountToClose: 'Vennligst velg kredittkortet du ønsker å avslutte',
    closeCreditAccountFormSelectAccountToReceive:
        'Vennligst velg bankkonto for utbetaling av eventuelt beløp til gode.',
    closeCreditAccountFormWriteAccountToReceive:
        'Vennligst oppgi bankkonto for utbetaling av eventuelt beløp til gode.',
    closeCreditAccountFormCustomAccountOption: 'Skriv inn et eget kontonummer',
    closeCreditAccountFormNoAccountOption: 'Ingen',

    closeCreditAccountFormNotChosenAccount: 'Du har ikke valgt noen konto å overføre dette til',
    closeCreditAccountFormNotChosenAccountWarning:
        'Er du sikker? Vi anbefaler å velge en bankkonto for utbetaling av eventuelt beløp til gode.',
    closeCreditAccountFormNotWrittenAccountWarning:
        'Er du sikker? Vi anbefaler å oppgi en bankkonto for utbetaling av eventuelt beløp til gode.',

    closeCreditAccountFormConfirmHeader: 'Bekreft oppsigelse av kredittkort',
    closeCreditAccountFormIAmSure: 'Send inn oppsigelsen',

    closeCreditAccountFormCloseSuccessReceiptDescription:
        'Du vil motta en e-post når oppsigelsen er ferdigbehandlet. Dette vil normalt skje innen en ukes tid. I noen tilfeller kan det også ta noe lengre tid dersom du har utestående saldo eller beløp til gode.',
    closeCreditAccountFormCloseSuccessReceiptWithdraw:
        'Oppsigelsen kan ikke trekkes tilbake. Ønsker du å ha kredittkort hos oss, må du søke på nytt. Har du spørsmål vedrørende oppsigelsen kan du sende en e-post til:',
    closeCreditAccountWithdrawEmail: 'kundesenter@eika.no',
    closeCreditAccountFormCloseSuccessHeader: 'Oppsigelsen er sendt inn.',
    closeCreditAccountFormCloseSMSWhenDescription: 'når oppsigelsen er sendt inn.',

    closeCreditAccountFormNotAllowedNotOwner: 'Du må være eier av kontoen for å kunne avslutte kortet',
    closeCreditAccountFormCloseError: 'Noe gikk galt under oppsigelse av kredittkort. Vennligst prøv igjen senere.',
    closeCreditAccountNotFoundError: 'Vi fant ikke kontoen du prøver å avslutte.',
    closeCreditAccountsEmptyListError: 'Fant ingen kort du kan avslutte.',
    closeCreditAccountDuplicateAccountCloseError: 'Dette kortet er allerede i en avslutningsprosess.',

    // V3 CLOSE ACCOUNT

    closeCreditAccountFeedbackTitle: 'Hvorfor ønsker du å avslutte kredittkortavtalen?',

    closeCreditAccountFeedbackOption1: 'Bruker kun bankkort',
    closeCreditAccountFeedbackOption2: 'Bruker andre kredittkort',
    closeCreditAccountFeedbackOption3: 'Ikke fornøyd med avtalens renter og betingelser',
    closeCreditAccountFeedbackOption4: 'Ikke fornøyd med avtalens fordeler',
    closeCreditAccountFeedbackOptionOther: 'Annet',

    closeCreditAccountFeedbackInputPlaceholder: 'Skriv årsaken her',

    // WORTH KNOWING

    worthKnowingHeader: 'Verdt å merke seg',
    worthKnowingSubHeader: 'Ved å si opp denne avtalen. blir kortet sperret umiddelbart og du mister disse fordelene.',

    worthKnowingInsurance: 'Reise- og avbestillingsforsikring',
    worthKnowingDigitalCard: 'Digitalt kort vil bli sperres for betaling',
    worthKnowingDigitalWallet:
        'Kortet blir sperret for bruk i Vipps, Google Pay, Samsung Pay, Apple Pay, smart-tilbehør og andre lommebøker',
    worthKnowingValueProgram: 'Kortets fordelsprogram og muligheten til å opptjene rabatter',
    worthKnowingIdInsurance: 'ID-tyveriforsikring',

    // TRANSFER FORM
    transferFormRadioButtonsLabel: 'Vennligst velg bankkonto for utbetaling av eventuelt beløp til gode.',
    transferFormOptionCustom: 'Custom',
    transferFormOptionCustomLabel: 'Skriv inn et eget kontonummer',
    transferFormOptionNone: 'None',
    transferFormOptionNoneLabel: 'Ingen',
    transferFormInvalidAccountNumber: 'Ugyldig kontonummer',
    transferFormSharedBy: 'Konto delt av {firstName} {lastName}',

    // SUMMARY

    summaryCardInfo: 'Du har valgt å avslutte ditt|?|{cardName}|?|({cardNumber}).|?|med kontonummer|?|{accountNumber}.',
    summaryCardCreditTransfer:
        'Det eventuelle beløpet til gode vil bli overført til {accountName}|?|({accountNumber}).',
    summaryCardSmsConfirmation:
        'Det blir sendt en bekreftelse på SMS til mobilnummer|?|{mobileNumber}|?|når oppsigelsen er sendt inn.',
    summaryCardNotice:
        'Merk at ved å si opp denne avtalen, blir kortet sperret umiddelbart, og blir utilgjengelig for bruk. Oppsigelsen kan ikke trekkes tilbake.',
    summaryModalContentSuccess1: 'Du vil motta en e-post når oppsigelsen er ferdigbehandlet',
    summaryModalContentSuccess2: 'Dette vil normalt skje innen en ukes tid dersom du ikke har utestående beløp',
    summaryModalSuccessCardTitle: 'Din kredittkortavtale er avsluttet',
    summaryGoBackToCard: 'Gå tilbake til Kort',
    summarySendIn: 'Send inn oppsigelse',
    summaryModalErrorMessage: 'Noe gikk galt',
};
